import "../../styles/all.css"
import "../../styles/theme.css"
import "./static.css"
import VisitorHeatmap from "../draw/heatmap"
function Static(){
    return(
        <>
        <div className="static">
            <div className="startt">
                <h4>Social Stastics</h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="heatmap">
                <VisitorHeatmap/>

            </div>
        </div>
        </>
    )
}
export default Static